import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material'
import { IconButton, styled, useMediaQuery, useTheme } from '@mui/material'
import { useState } from 'react'
import { Carousel as ReactCarousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import Slide1 from './slides/Slide1'
import Slide2 from './slides/Slide2'
import Slide3 from './slides/Slide3'

const Wrapper = styled('section')(({ theme }) => ({
  padding: 0,
  '& .slider': {
    position: 'relative',
    height: 'auto',
    overflowX: 'visible'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '0 20px'
  },
  [theme.breakpoints.up('xl')]: {
    padding: 0
  }
}))

export default function Carousel() {
  const theme = useTheme()
  const hideArrows = useMediaQuery(theme.breakpoints.down('lg'))
  const [currentSlide, setCurrentSlide] = useState(0)
  const updateCurrentSlide = (index: number) => {
    if (currentSlide !== index) {
      setCurrentSlide(index)
    }
  }

  return (
    <Wrapper>
      <ReactCarousel
        autoPlay
        infiniteLoop
        interval={10000}
        renderArrowPrev={(clickHandler) =>
          hideArrows ? undefined : (
            <div style={{ position: 'absolute', zIndex: 2, top: 0, left: 0, height: '100%', display: 'flex', alignItems: 'center' }}>
              <IconButton sx={{ backgroundColor: theme.palette.customBlue[50] }} onClick={clickHandler}>
                <ArrowBackIosNew color="primary" />
              </IconButton>
            </div>
          )
        }
        renderArrowNext={(clickHandler) =>
          hideArrows ? undefined : (
            <div style={{ position: 'absolute', zIndex: 2, top: 0, right: 0, height: '100%', display: 'flex', alignItems: 'center' }}>
              <IconButton sx={{ backgroundColor: theme.palette.customBlue[50] }} onClick={clickHandler}>
                <ArrowForwardIos color="primary" />
              </IconButton>
            </div>
          )
        }
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          const style = { fontSize: 36, marginLeft: 20, color: theme.palette.customBlue[200], cursor: 'pointer' }
          if (isSelected) style.color = theme.palette.primary.main
          return (
            <span
              style={style}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              key={index}
              role="button"
              tabIndex={0}
              aria-label={`${label} ${index + 1}`}
            >
              &bull;
            </span>
          )
        }}
        showThumbs={false}
        showStatus={false}
        showArrows
        showIndicators
        selectedItem={currentSlide}
        onChange={updateCurrentSlide}
        preventMovementUntilSwipeScrollTolerance
        swipeScrollTolerance={50}
      >
        <Slide1 />
        <Slide2 />
        <Slide3 />
      </ReactCarousel>
    </Wrapper>
  )
}
